import request from "@/utils/request";

export function getCarInfo(vin) {
  return request({
    url: "/mgr/partCatalogs/car/info",
    method: "get",
    params: { q: vin },
  });
}

export function getGroupsTree(catalogId, data) {
  return request({
    url: `/mgr/partCatalogs/catalogs/${catalogId}/groups-tree`,
    method: "get",
    params: data,
  });
}

export function getSchemas({ catalogId, data, signal }) {
  return request({
    url: `/mgr/partCatalogs/catalogs/${catalogId}/schemas`,
    method: "get",
    params: data,
    signal,
  });
}

export function getPartS2(catalogId, data) {
  return request({
    url: `/mgr/partCatalogs/catalogs/${catalogId}/parts2`,
    method: "get",
    params: data,
  });
}

export function getMappingPncNumber(data) {
  return request({
    url: `/mgr/stripList/mappingByPncNumber`,
    method: "post",
    data,
  });
}

export function getPartSuggestions({ catalogId, query, signal }) {
  return request({
    url: `/mgr/partCatalogs/catalogs/${catalogId}/groups-suggest`,
    method: "get",
    params: { q: query },
    signal,
  });
}

export function getDefaultPartPrice(data) {
  return request({
    url: `/mgr/defaultPrice/getDefaultPrice`,
    method: "get",
    params: data,
  });
}

export function saveDefaultPartPrice(data) {
  return request({
    url: `/mgr/defaultPrice/saveDefaultPrice`,
    method: "post",
    data,
  });
}

export function getAutoSelectParts(make) {
  return request({
    url: `/mgr/vehicleAutoSelect/getAutoSelectPart`,
    method: "get",
    params: { make },
  });
}

export function getPriceAndAvailability({ parts, pageNum, pageSize }, signal) {
  return request({
    url: `/mgr/inventory/getPA`,
    method: "post",
    data: parts,
    params: {
      pageNum,
      pageSize,
    },
    signal,
  });
}
